import React, { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ControlGroup from "@amzn/meridian/control-group";
import {viewChanged} from "../../actions/OptionsActions";
import RadioButton from "@amzn/meridian/radio-button";
import {FormattedMessage} from "react-intl";
import {Capability, ViewType} from "../../enums";
import {FEATURES} from "../../constants";
import {getNodeId, hasAmxlViewFlagEnabled} from "../../Utility";

class HeatMapViewOptions extends Component {
    render() {

        const {selectedView} = this.props;
        return (
            <ControlGroup label={<FormattedMessage id="heatMapViewOptions.view" defaultMessage="View"/>}
                          onChange={updatedView => this.handleViewChange(updatedView)} value={selectedView}>
                {!hasAmxlViewFlagEnabled(getNodeId(), this.props.featureStatus) &&
                    <RadioButton value={ViewType.DEFAULT_VIEW} data-cy={"heatMapFieldsetOption"}>
                        {this.renderDefaultOption()}
                    </RadioButton>
                }
                <RadioButton value={ViewType.ROUTE_VIEW} data-cy={"heatMapFieldsetOption"}>
                    <FormattedMessage id="heatMapViewOptions.routeView" defaultMessage="Route"/>
                </RadioButton>
                {this.isSidelineVisibilityEnabled() &&
                    <RadioButton value={ViewType.SIDELINE_VIEW} data-cy={"heatMapFieldsetOption"}>
                        <FormattedMessage id="heatMapViewOptions.sidelineView" defaultMessage="Sideline"/>
                    </RadioButton>
                }
            </ControlGroup>
        )
    }

    handleViewChange(updatedView) {
        this.props.dispatch(viewChanged(updatedView))
    }
    renderDefaultOption() {
        const capability = this.props.capability
        switch (capability) {
            case Capability.AR_NEXT_GEN:
                return <FormattedMessage id="heatMapViewOptions.stationPairView" defaultMessage="Station"/>
            case Capability.SSD:
                return <FormattedMessage id="heatMapViewOptions.zone" defaultMessage="Zone"/>
            default:
                return <FormattedMessage id="heatMapViewOptions.clusterView" defaultMessage="Cluster"/>
        }
    }

    isSidelineVisibilityEnabled() {
        return this.props.capability === Capability.AMZL && this.props.featureStatus &&
            this.props.featureStatus[FEATURES.SIDELINE_STOW_VISIBILITY];
    }
}

const mapStateToProps = state => ({
    capability: state.optionsReducer.capability,
    selectedView: state.optionsReducer.heatMapView,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(HeatMapViewOptions));


// WEBPACK FOOTER //
// ./src/components/options/HeatMapViewOptions.js